import { request, ENDPOINTS } from "./api";

export const getHapu = async () => {
    const { hapu } = await request.get(ENDPOINTS.groups);
    const getHapu = (name) => {
        const h = hapu.find(({ value }) => value === name);

        if (!h) {
            console.error(name, hapu);
            throw new Error(`Could not find get hapu ${name}`);
        }

        return h.value;
    };

    return {
        Rangituhia: {
            description: getHapu("Ngāti Rangituhia"),
            id: 633015,
        },
        Parenga: {
            description: getHapu("Ngāti Parenga"),
            id: 633006,
        },
        Uenukumanawawiri: {
            description: getHapu("Ngāti Uenukumanawawiri"),
            id: 633007,
        },
        "Tuhi Ariki": {
            description: getHapu("Ngāti Tuhi Ariki"),
            id: 633008,
        },
        "Tui-o-Nuku": {
            description: getHapu("Ngāti Tui-o-Nuku"),
            id: 633009,
        },
        Rangihaereroa: {
            description: getHapu("Ngāti Rangihaereroa"),
            id: 633010,
        },
        Rangiteauria: {
            description: getHapu("Ngāti Rangiteauria"),
            id: 633011,
        },
        Tongaiti: {
            description: getHapu("Ngāti Tongaiti"),
            id: 633012,
        },
        Patutokotoko: {
            description: getHapu("Ngāti Patutokotoko"),
            id: 633013,
        },
        Hioi: {
            description: getHapu("Ngāti Hioi"),
            id: 633014,
        },
        Uenuku: {
            description: getHapu("Ngāti Uenuku"),
            id: 633016,
        },
        Tamakana: {
            description: getHapu("Ngāti Tamakana"),
            id: 633017,
        },
        Tupoho: {
            description: getHapu("Ngāti Tupoho"),
            id: 633018,
        },
        "Rangi-ki-tai": {
            description: getHapu("Ngāti Rangi-ki-tai"),
            id: 633018,
        },
    };
};
